import { Collapsible } from '@cloudflare/kumo';
import { CaretRight } from '@phosphor-icons/react';
import type { ReactNode } from 'react';

export function CollapsibleTrigger({ children }: { children: ReactNode }) {
  return (
    <Collapsible.Trigger className="group inline-flex cursor-pointer items-center gap-1.5 text-sm font-semibold">
      {children}
      <CaretRight
        size={14}
        aria-hidden="true"
        className="shrink-0 transition-transform group-data-panel-open:rotate-90"
      />
    </Collapsible.Trigger>
  );
}
